module.exports = __webpack_public_path__ + "static/img/adopt.9639f85b.png";